const DATA_LOSS_MESSAGE =
  'You have entered details that have not been saved. Going back will lose all unsaved data. Continue anyway?';

const EXIT_FORM_MESSAGE =
  'You have entered form details. Going back will lose all data. Continue anyway?';

export function confirmDataLoss(message = DATA_LOSS_MESSAGE): boolean {
  return window.confirm(message);
}

export function confirmExitForm(): boolean {
  return confirmDataLoss(EXIT_FORM_MESSAGE);
}

export function hasUnsavedChanges(saved: unknown, current: unknown): boolean {
  return JSON.stringify(saved ?? null) !== JSON.stringify(current ?? null);
}

export function guardUnsavedBack(saved: unknown, current: unknown, onBack: () => void): void {
  if (!hasUnsavedChanges(saved, current) || confirmDataLoss()) {
    onBack();
  }
}

export function guardExitForm(hasContent: boolean, onLeave: () => void): void {
  if (!hasContent || confirmExitForm()) {
    onLeave();
  }
}

export function hasAnyFieldData(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'number') return !Number.isNaN(value);
  if (typeof value === 'boolean') return value;
  if (Array.isArray(value)) return value.some(hasAnyFieldData);
  if (typeof value === 'object') {
    return Object.values(value as Record<string, unknown>).some(hasAnyFieldData);
  }
  return false;
}

export function hasAnySectionProgress(sectionStatus?: Record<string, string>): boolean {
  if (!sectionStatus) return false;
  return Object.values(sectionStatus).some((s) => s === 'complete' || s === 'incomplete');
}

export function hasPrfFormContent(data: Record<string, unknown>): boolean {
  if (hasAnySectionProgress(data.sectionStatus as Record<string, string> | undefined)) {
    return true;
  }
  const { sectionStatus: _, ...sections } = data;
  return hasAnyFieldData(sections);
}

export function hasMinorInjuryFormContent(input: {
  patientDetails: unknown;
  nokDetails: unknown;
  presentingComplaint: unknown;
  attending: unknown;
  closingDetails: unknown;
  sectionStatus: Record<string, string>;
}): boolean {
  if (hasAnyFieldData(input.closingDetails)) return true;
  if (hasAnySectionProgress(input.sectionStatus)) return true;
  return hasAnyFieldData({
    patientDetails: input.patientDetails,
    nokDetails: input.nokDetails,
    presentingComplaint: input.presentingComplaint,
    attending: input.attending,
  });
}
